import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { action, autorun, observable, computed, toJS } from 'mobx';
import { Link } from 'react-router';
import Form, { FormBody, FormActions, SelectInput, TextInput, DateInput } from '../../Form';
import DataTable from '../../DataTable';
import Spinner from '../../Spinner';
import { getDisplayDate, toUtc } from '../../../libs/date';
import moment from 'moment';
// import _ from 'lodash';
// import HierTable from '../../HierTable';

@inject('stationStore', 'rolePermissionStore', 'qcRuleStore', 'qcCheckStore', 'parameterStore')
@observer
class StationQcCheckList extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
  };

  @observable isLoading = false;
  @observable items = [];
  @observable qcChecks = [];
  @observable itemsChanged = {};
  @observable dataSeriesFilterItems = [];
  @observable dataSeriesFilterItem = null;
  @observable dataSeriesItems = [];
  @observable selectedQcRule = '';
  @observable selectedDataSeries = '';
  @observable dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD');
  @observable dateTo = moment().format('YYYY-MM-DD');

  @computed get qcRulesForSelectedDataSeries() {
    if (!this.selectedDataSeries) return [];
    let dataSeries = this.dataSeriesItems.find(item => +item.id === +this.selectedDataSeries);
    return this.qcChecks.filter(item => +item.parameter_id === +dataSeries.parameter_id);
  }

  dispose;
  componentWillMount() {
    const { notify } = this.context;
    const { params: { id }, stationStore, qcCheckStore, qcRuleStore, parameterStore } = this.props;

    if (!qcRuleStore.items.lenght && !qcRuleStore.isLoading) qcRuleStore.fetchItems();
    if (!parameterStore.items.lenght && !parameterStore.isLoading) parameterStore.fetchItems();
    stationStore.fetchDataSeries(id)
      .then(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems.map(item => (Object.assign(item, {parameter: parameterStore.findById(item.parameter_id)})));
      });
    qcCheckStore.fetchStationQcRules(id).then(res => {
      this.qcChecks = res;
    })

  }

  onChangeQcRule = e => this.selectedQcRule = e.target.value;
  onChangeDataSeries = e => this.selectedDataSeries = e.target.value;
  onChangeDateFrom = e => this.dateFrom = e.target.value;
  onChangeDateTo = e => this.dateTo = e.target.value;

  @action onChangeHqc = (id, e) => {
    this.items = this.items
      .map(item => {
        if (item.id === id) {
          return Object.assign({}, item, {
            hqc: e.target.value,
          });
        }
        return item;
      });

    if (!this.itemsChanged[id]) {
      this.itemsChanged[id] = {};
    }
    this.itemsChanged[id].hqc = e.target.value;
  }


  @action onChangeValue = (id, e) => {
    this.items = this.items
      .map(item => {
        if (item.id === id) {
          return Object.assign({}, item, {
            value: e.target.value,
          });
        }
        return item;
      });

    if (!this.itemsChanged[id]) {
      this.itemsChanged[id] = {};
    }
    this.itemsChanged[id].value = e.target.value;
  }

  @action saveHqc = () => {
    const { notify } = this.context;
    const { params: { id }, stationStore } = this.props;
    this.isSaving = true;
    const itemsChangedArray = Object.keys(this.itemsChanged)
      .map(id => {
        return Object.assign({}, this.itemsChanged[id], {
          id,
        });
      });
    stationStore.saveQcChecks(id, itemsChangedArray)
      .then(action(() => {
        this.isSaving = false;
        // this.reset(items);
      }))
      .catch(action(err => {
        this.isSaving = false;
        notify.error(err);
      }));
  }

  onView = (e) => {
    e.preventDefault();

    this.isLoading = true;
    this.items = [];
    const {qcCheckStore, qcRuleStore, params: {id}} = this.props;
    let rule = this.qcChecks.find(item => +item.id === +this.selectedQcRule);
    qcCheckStore.fetchCheckLogs({station_id: id, series_id: this.selectedDataSeries, rule_id: rule ? rule.qc_rule_id : '', date_from: moment(this.dateFrom).format('YYYY-MM-DDT00:00:00'), date_to: moment(this.dateTo).add(1, 'days').format('YYYY-MM-DDT00:00:00')})
      .then(res => {
        this.items = res.map(item => (Object.assign(item, {time: getDisplayDate(item.time)})));

        // // for heirtable
        // let items = [];
        // let checkLogsGroupedByObservation = _.groupBy(res, item => item.observation_id.toString());
        // Object.keys(checkLogsGroupedByObservation).forEach(observation_id => {
        //   let observation1 = checkLogsGroupedByObservation[observation_id][0];
        //   items.push({
        //     level: 1,
        //     id: observation_id,
        //     data_series: observation1.data_series,
        //     time: getDisplayDate(observation1.time),
        //     value: observation1.value
        //   });
        //   checkLogsGroupedByObservation[observation_id].forEach(log => {
        //     items.push({
        //       level: 2,
        //       parent_id: observation_id,
        //       quality: log.quality,
        //       error_message: log.error_message,
        //       data_series: qcRuleStore.findById(log.qc_rule_id).description
        //     })
        //   })
        // })
        // this.items = items;

        this.isLoading = false;
      })
      .catch(err => {
        this.isLoading = false;
        console.log('check logs fetch error', err);
      })
  }

  render() {
    const { params: { id }, rolePermissionStore, parameterStore } = this.props;
    let modifyPermission = rolePermissionStore.validateRole('modify qc-check');
    // Parameter Name, Time, Value, QC Flag
    const columns = [
      // { key: 'id', label: 'ID', colClassName: 'level-2-align-right' },
      // { key: 'parameter_code', label: 'Parameter Name' },
      { key: 'observation_id', label: 'Observation ID'},
      { key: 'data_series', label: 'Data Series' },
      { key: 'time', label: 'Time' },
      { key: 'value', label: 'Value', options: modifyPermission ? { type: 'number', onChange: this.onChangeValue } : null },
      { key: 'hqc', label: 'HQC', sortable: true, options: modifyPermission ? { type: 'number', onChange: this.onChangeHqc, min: 0, max: 9 } : null },
      { key: 'qc2', label: 'QC2', sortable: true },
      { key: 'quality', label: 'QC1', sortable: true },
      { key: 'qc0', label: 'QC0', sortable: true },
      { key: 'error_message', label: 'Error Message' },
      // { key: 'data_origin', label: 'Data Origin' },
    ];

    // if (this.isLoading) { return <Spinner />; }

    return (
      <div>
        <Form>
          <FormBody>
            <SelectInput
              label={'Data Series'}
              fields={{ label: 'name', value: 'id' }}
              options={this.dataSeriesItems}
              onChange={this.onChangeDataSeries}
              value={this.selectedDataSeries}
              filterOptions={(options, filterText) => parameterStore.filterParameters(options, filterText, 'parameter.code')}
            />
            <SelectInput
              label={'QC Rules'}
              fields={{ label: 'name', value: 'id' }}
              options={this.qcRulesForSelectedDataSeries}
              onChange={this.onChangeQcRule}
              value={this.selectedQcRule}
            />
            <DateInput
              label={'Date From'}
              value={this.dateFrom}
              onChange={this.onChangeDateFrom}
            />
            <DateInput
              label={'Date To'}
              value={this.dateTo}
              onChange={this.onChangeDateTo}
            />
          </FormBody>
          <FormActions>
            <button onClick={this.onView}>View</button>
          </FormActions>
        </Form>
        {modifyPermission && <button className="small button right" onClick={this.saveHqc}>Save</button>}
        <DataTable
          data={this.items.filter(item => (!!this.selectedDataSeries ? +item.series_id === +this.selectedDataSeries : true) && (!!this.selectedQcRule ? +item.qc_rule_id === +this.qcChecks.find(item => +item.id === +this.selectedQcRule).qc_rule_id : true))}
          slug={'qc-check'}
          columns={columns}
          resource='qc-check'
        />
        {/* {this.items.length > 0 && <HierTable
          // data={this.items.filter(item => (!!this.selectedDataSeries ? +item.series_id === +this.selectedDataSeries : true) && (!!this.selectedQcRule ? +item.qc_rule_id === +this.qcChecks.find(item => +item.id === +this.selectedQcRule).qc_rule_id : true))}
          data={this.items}
          slug={'qc-check'}
          columns={columns}
          resources={{parent: 'qc-check', child: 'qc-check'}}
        />} */}
        {this.isLoading && <Spinner/>}
      </div>
    );
  }
}

export default StationQcCheckList;



// WEBPACK FOOTER //
// ./src/components/Station/QcCheck/StationQcCheckList2.js